import { useRef, useState, useEffect } from 'react';
import { API_ROUTES, clearFlashMessages, DEVICES_LIST, setFlashMessage, TRANS_SS_MODES, userIsLogged, userRedirectLogin } from '../../../helpers';
import HousePilotDeviceBox from './Device_Box';

import $ from 'jquery';
import HousePilotDeviceBoxCE from './Device_Box_CE';
import HousePilotDeviceBoxSS from './Device_Box_SS';
import House from '../House';
import HousePilotDeviceBoxSpa from './Device_Box_Spa';
import HousePilotModalMetrics from './Modal_Metrics';
const REFRESH_INTERVAL = 30 * 1000
let lastUpdateDate

export class HousePilotManager {
    constructor() {
        this._atlanticLoaded = false
        this._spaLoaded = false
        this._weatherLoaded = false
        this._tuyaLoaded = false
        this._devicesData = {}
        this._responseTimesNoCache = {
            atlantic: null,
            spa: null,
            weather: null,
            tuya: null
        }
    }

    loadDeviceDataIntoTemplate(clearCache = false) {
        // Load Atlantic data first
        this.loadDevicesData(clearCache, 'atlantic').then((data) => {
            if (data?.devicesData) {
                this._setDevicesData(data.devicesData)
                this._atlanticLoaded = true
            }
        })

        // Load SPA data independently
        this.loadDevicesData(clearCache, 'spa').then((data) => {
            if (data?.devicesData) {
                this._setSpaData(data.devicesData)
                this._spaLoaded = true
            }
        })

        // Load Tuya data independently
        this.loadDevicesData(clearCache, 'tuya').then((data) => {
            if (data?.tuya) {
                this._setTuyaData(data.tuya)
                this._tuyaLoaded = true
            }
        })

        // Load weather data independently
        this.loadDevicesData(clearCache, 'weather').then((data) => {
            if (data?.weather) {
                this._setWeatherData(data.weather)
                this._weatherLoaded = true
            }
        })
    }

    async changeMode(newMode) {
        await this.requestChangeState('MAIN', 'SET_MODE', newMode)
    }

    async requestChangeState(deviceName, operationName, operationValue) {
        return new Promise((resolve, reject) => {
            const deviceLabel = DEVICES_LIST.find(o => o.name === deviceName).label || deviceName
            $.post(API_ROUTES.DEVICES_CHANGE_STATE, {
                deviceName: deviceName,
                operation: operationName,
                value: operationValue
            }, (data) => {
                let flashMessage
                if (operationName === 'SET_TEMP') {
                    flashMessage = deviceLabel + ' : '
                    let temperatureMsgPart = 'température changée à ' + operationValue + ' °C'
                    if (data.state === 'STOP') {
                        flashMessage += 'arrêté'
                    } else if (data.state === 'START') {
                        flashMessage += 'démarré et ' + temperatureMsgPart
                    } else {
                        flashMessage += temperatureMsgPart
                    }
                }
                if (operationName === 'SET_MODE') {
                    flashMessage = 'Mode pour ' + deviceLabel + ' changé à ' + operationValue.toUpperCase();
                }
                if (deviceName == 'SPA') {
                    flashMessage = 'Opération <b>' + operationName + '</b> à ' + operationValue + ' effectuée pour le SPA';
                }
                setFlashMessage('success', flashMessage)
                resolve()
            }
            ).fail(error => {
                let msg = 'Echec du changement de statut pour <b>' + deviceName + '</b> operation <b>' + operationName + '</b> avec paramètre <b>' + operationValue + '</b>, <br/>Trace :';
                if (error.responseJSON && error.responseJSON.output) {
                    msg += ' ' + JSON.stringify(error.responseJSON.output);
                }
                setFlashMessage('error', msg);
                reject()
            }).always(() => {
                this.loadDeviceDataIntoTemplate()
            });
        })
    }

    async loadDevicesData(clearCache = false, dataGroup = 'atlantic') {
        return new Promise((resolve, reject) => {
            let url = new URL(API_ROUTES.DEVICES_GET_DATA, window.location.origin)
            url.searchParams.append('dataGroup', dataGroup)
            if (clearCache === true) {
                url.searchParams.append('cc', 'true')
            }
            $.get(url.toString(), (data) => {
                if (data?.meta?.date) {
                    lastUpdateDate = 'Actualisé ' + data.meta.date
                }
                if (data.meta?.responseTime) {
                    this._responseTimesNoCache[dataGroup] = data.meta.responseTime
                }
                resolve(data)
                if ($('#flashMessages div').first().text().includes('Echec du chargement des données')) {
                    clearFlashMessages()
                }
            }
            ).fail(error => {
                let msg = 'Echec du chargement des données';
                if (dataGroup === 'atlantic') {
                    msg += ' (Chauffage - Climatisation)';
                } else if (dataGroup === 'spa') {
                    msg += ' (SPA)';
                }
                if (error.responseJSON && error.responseJSON.output) {
                    msg += ' : ' + error.responseJSON.output;
                }
                setFlashMessage('error', msg);
                resolve()
            }).always(() => {
            });
        })
    }



    getDevicesBoxTemplate() {
        const devicesData = this._devicesData
        if (!devicesData) {
            return []
        }

        const deviceBoxes = []
        const mainMode = devicesData['MAIN']?.passAPCOperatingModeState

        // Add Atlantic devices if loaded
        if (this._atlanticLoaded) {
            Object.keys(devicesData)
                .filter(deviceName => deviceName.startsWith('R_') || deviceName === 'O_CE' || deviceName === 'O_SS')
                .forEach(deviceName => {
                    if (deviceName.startsWith('R_')) {
                        const deviceData = devicesData[deviceName]
                        deviceBoxes.push(<HousePilotDeviceBox
                            key={deviceName}
                            isActive={deviceData.isActive}
                            deviceName={deviceName}
                            deviceLabel={deviceData.label}
                            deviceCurrentTemp={deviceData.temperatureState}
                            deviceTargetTemp={deviceData.targetTemperature}
                            mainMode={mainMode}
                            onStateChange={onStateChange}
                        />)
                    } else if (deviceName === 'O_CE') {
                        const dataCE = devicesData['O_CE']
                        deviceBoxes.push(<HousePilotDeviceBoxCE
                            key={deviceName}
                            deviceName={deviceName}
                            deviceLabel='CHAUFFE-EAU'
                            isActive={dataCE.isActive}
                            currentTemp={dataCE.middleWaterTemperatureState}
                            targetTemp={dataCE.temperatureState}
                            consoTotal={dataCE.deviceConsoToday / 1000}
                            progPump={dataCE.operatingRangeState}
                            progPumpDetails={dataCE.prog}
                            pumpHeat={dataCE.powerHeatPumpState}
                            _isBoostActive={dataCE.boostMode}
                            _isAbsenceMode={dataCE.operatingModeState.absence === 'on'}
                        />)
                    } else if (deviceName === 'O_SS') {
                        const dataSS = devicesData['O_SS']
                        deviceBoxes.push(<HousePilotDeviceBoxSS
                            key={deviceName}
                            deviceName={deviceName}
                            deviceLabel={dataSS.label}
                            mode={dataSS.targetHeatingLevelState}
                            availableModes={TRANS_SS_MODES}
                            onStateChange={onStateChange}
                        />)
                    }
                })
        }

        // Add SPA device if loaded
        if (this._spaLoaded && this._spaData['SPA']) {
            const dataSpa = this._spaData['SPA']
            deviceBoxes.push(
                <HousePilotDeviceBoxSpa
                    key="SPA"
                    isFiltering={dataSpa.filter}
                    isSanitize={dataSpa.sanitizer}
                    isHeating={dataSpa.heater}
                    error={dataSpa.error}
                    currentTemp={dataSpa.current_temp}
                    targetTemp={dataSpa.preset_temp}
                    errorCode={dataSpa.error_code}
                    isPowered={dataSpa.power}
                    onStateChange={onStateChange}
                />
            )
        }

        return deviceBoxes
    }

    clearDataCache() {
        // Reset response times
        this._responseTimesNoCache = {
            atlantic: null,
            spa: null,
            weather: null,
            tuya: null
        }
        // Load with true to clear all caches
        this.loadDeviceDataIntoTemplate(true)
    }

    async checkMaintenance() {
        try {
            const res = await fetch(API_ROUTES.SAUTER_SERVICE_MAINTENANCE, { method: 'GET' })
            const data = await res.json()
            if (typeof data === 'boolean') {
                this._setMaintenanceActive(Boolean(data))
            } else if (data && typeof data.inMaintenance !== 'undefined') {
                this._setMaintenanceActive(Boolean(data.inMaintenance))
            } else if (data && data === true) {
                this._setMaintenanceActive(true)
            }
        } catch (e) {
            console.error('Maintenance check failed', e)
        }
    }


}

const manager = new HousePilotManager()

async function onStateChange(deviceName, operationName, operationValue) {
    await manager.requestChangeState(deviceName, operationName, operationValue)
}


export default function HousePilot() {
    const [isLogged, setIsLogged] = useState(false)
    // maintenance state: checked => we've attempted the backend check
    const [maintenanceActive, setMaintenanceActive] = useState(null)

    const [devicesData, setDevicesData] = useState(null)
    const [spaData, setSpaData] = useState(null)
    const [weatherData, setWeatherData] = useState(null)
    const [tuyaData, setTuyaData] = useState(null)
    const [canShowModalMetricsShogun, setCanShowModalMetricsShogun] = useState(false)
    const [canShowModalMetricsAbri, setCanShowModalMetricsAbri] = useState(false)
    let refRefreshIntervalId = useRef(null)

    manager._devicesData = devicesData
    manager._spaData = spaData
    manager._setDevicesData = setDevicesData
    manager._setSpaData = setSpaData
    manager._setWeatherData = setWeatherData
    manager._setTuyaData = setTuyaData
    manager._setMaintenanceActive = setMaintenanceActive

    if (isLogged !== true) {
        userIsLogged().then((isLogged) => {
            if (isLogged === false) {
                userRedirectLogin()
            }
            setIsLogged(isLogged)
        })
    }

    if (maintenanceActive === null) {
        manager.checkMaintenance()
    }

    if (devicesData === null) {
        manager.loadDeviceDataIntoTemplate()
    }

    if (refRefreshIntervalId?.current === null) {
        refRefreshIntervalId.current = setInterval(() => {
            manager.loadDeviceDataIntoTemplate()
        }, REFRESH_INTERVAL)
    }

    function isLoaded() {
        return manager._atlanticLoaded || manager._spaLoaded || manager._weatherLoaded || manager._tuyaLoaded
    }

    let shogunErrorCode = null
    let mainMode = null
    if (devicesData && devicesData['MAIN']) {
        mainMode = devicesData['MAIN']?.passAPCOperatingModeState
        const shogunErrorCodeInt = devicesData['MAIN']?.errorCodeState
        const shogunErrorCodeStr = shogunErrorCodeInt.toString()
        if (shogunErrorCodeInt >= 0 && shogunErrorCodeStr.length > 1)
            shogunErrorCode = shogunErrorCodeStr.substring(0, shogunErrorCodeStr.length - 1) + '.' + shogunErrorCodeStr[shogunErrorCodeStr.length - 1]
    }

    const powerValues = {
        consoToday: tuyaData?.powerInfo?.consoToday ? (tuyaData?.powerInfo?.consoToday / 1000).toFixed(1) : null,
        powerW: tuyaData?.powerInfo?.values?.P ? (tuyaData?.powerInfo?.values?.P / 1000).toFixed(1) : null,
        intensityA: tuyaData?.powerInfo?.values?.A ? (tuyaData?.powerInfo?.values?.A).toFixed(1) : null
    }
    const powerValuesExt = {
        consoToday: tuyaData?.powerInfoExt?.consoToday ? (tuyaData?.powerInfoExt?.consoToday / 1000).toFixed(1) : null,
        powerW: tuyaData?.powerInfoExt?.values?.P ? (tuyaData?.powerInfoExt?.values?.P / 1000).toFixed(1) : null,
        intensityA: tuyaData?.powerInfoExt?.values?.A ? (tuyaData?.powerInfoExt?.values?.A).toFixed(1) : null
    }
    const workingBlink = powerValues.intensityA > 0.3 ? <i className='fa fa-circle fadeInOut float-right' style={{ color: 'rgb(227 134 65)', fontSize: '1.3rem', paddingTop: '3px' }}></i> : ''

    const devicesBox = manager.getDevicesBoxTemplate()


    if (isLogged) {
        return (
            <>
                <House activeTab="pilotage" />
                {maintenanceActive && (
                    <div className="alert alert-warning text-center" style={{ margin: 0 }} role="alert">
                        Le serveur Cozytouch est indiqué en maintenance actuellement. <br />
                        L'application peut ne pas fonctionner (mais ce sera également le cas sur l'application mobile officielle).
                    </div>
                )}
                <div className="conteneur">
                    <div id="flashMessages"></div>

                    <div id="loader" className="text-center" style={{ display: isLoaded() ? 'none' : 'block' }}>
                        <img style={{ marginTop: "3rem", maxWidth: "128px" }} src={require('../../../resources/img/loader3.gif')} />
                    </div>
                    <div id="devicesDataPart" className="text-center" style={{ display: isLoaded() ? 'block' : 'none' }} >
                        <h4 className="">Chauffage - Climatisation</h4>
                        {manager._tuyaLoaded && (
                            <>
                                <div className='row row-full-width'>
                                    <div className="ml-4  deviceBox  col-10 col-md-6'" style={{ background: '#13617e' }}>
                                        <i className="fa fa-info-circle float-left cursor-pointer" data-dname="TUYA_SHOGUN" data-toggle="modal" data-target="#deviceMetrics" onClick={() => setCanShowModalMetricsShogun(true)}></i>
                                        SHOG. <strong>{powerValues.consoToday ? powerValues.consoToday : '--'} kWh </strong>
                                        | <strong>{powerValues.powerW ? powerValues.powerW : '--'} kWh </strong>
                                        <span>(
                                            {powerValues.intensityA ? powerValues.intensityA : '--'} A)
                                            {workingBlink}
                                        </span>
                                    </div>
                                    <HousePilotModalMetrics deviceLabel="SHOGUN" deviceName="TUYA_SHOGUN" showModal={canShowModalMetricsShogun} onModalClose={() => setCanShowModalMetricsShogun(false)} displayZeroValues={true} />
                                </div>
                                <div className='row row-full-width'>
                                    <div className="ml-4  deviceBox  col-10 col-md-6'" style={{ background: 'rgb(125 114 103)' }}>
                                        <i className="fa fa-info-circle float-left cursor-pointer" data-dname="TUYA_ABRI" data-toggle="modal" data-target="#deviceMetrics" onClick={() => setCanShowModalMetricsAbri(true)}></i>

                                        EXT <strong>{powerValuesExt.consoToday ? powerValuesExt.consoToday : '--'} kWh </strong>
                                        | <strong>{powerValuesExt.powerW ? powerValuesExt.powerW : '--'} kWh </strong>
                                        <span>(
                                            {powerValuesExt.intensityA ? powerValuesExt.intensityA : '--'} A)
                                        </span>
                                    </div>
                                    <HousePilotModalMetrics deviceLabel="ABRI" deviceName="TUYA_ABRI" showModal={canShowModalMetricsAbri} onModalClose={() => setCanShowModalMetricsAbri(false)} displayZeroValues={true} />
                                </div>
                            </>
                        )}
                        {manager._weatherLoaded && (
                            <div className='row  row-full-width'>
                                <div className="ml-4  deviceBox  col-10 col-md-6'" style={{ background: 'rgb(82 113 24)' }}>
                                    INT <strong>{weatherData && weatherData['IN'] && weatherData['IN']?.temperature ? (weatherData['IN']?.temperature).toFixed(1) : '--'} °C</strong> |
                                    HR <strong>{weatherData && weatherData['IN'] && weatherData['IN']?.humidity ? (weatherData['IN']?.humidity).toFixed(0) : '--'} %</strong> |
                                    C02 <strong>{weatherData && weatherData['IN'] && weatherData['IN']?.co2 ? (weatherData['IN']?.co2).toFixed(0) : '--'} ppm</strong>
                                    <br />
                                    EXT <strong>{weatherData && weatherData['OUT'] && weatherData['OUT']?.temperature ? (weatherData['OUT']?.temperature).toFixed(1) : '--'} °C</strong> |
                                    HR <strong>{weatherData && weatherData['OUT'] && weatherData['OUT']?.humidity ? (weatherData['OUT']?.humidity).toFixed(0) : '--'} %</strong> |
                                    PLU <strong>{weatherData && weatherData['RAIN'] && weatherData['RAIN']?.sum_1h ? (weatherData['RAIN']?.sum_1h).toFixed(0) : '--'}</strong>/
                                    <strong>{weatherData && weatherData['RAIN'] && weatherData['RAIN']?.sum_24h ? (weatherData['RAIN']?.sum_24h).toFixed(0) : '--'}</strong> mm
                                </div>
                            </div>
                        )}
                        <div className='row ml-2'>
                            <div className={"alert alert-warning " + (shogunErrorCode !== null ? 'd-block' : 'd-none')} style={{ "marginBottom": 0 }}>Erreur détectée sur l'installation <strong>(code {shogunErrorCode})</strong></div>
                        </div>

                        {manager._atlanticLoaded && (

                            <div className="text-center my-2" id="mainMode" >
                                <select className="form-control d-inline-block" style={{ maxWidth: "250px" }} onChange={(e) => { manager.changeMode(e.target.value) }} defaultValue={mainMode}>
                                    <option value="heating"> Mode Chauffage</option>
                                    <option value="cooling"> Mode Climatisation</option>
                                    <option value="stop">Arrêt</option>
                                </select>
                            </div>
                        )}
                        <div className="row ml-1 mr-1 mb-3" id="deviceBoxes">
                            {devicesBox}
                        </div>

                        <div className="text-center small"><span id="tableDateUpdate">{lastUpdateDate} </span>
                            <img onClick={() => { manager.loadDeviceDataIntoTemplate() }} src={require('../../../resources/img/refresh.png')} className="cursor-pointer"
                                style={{ width: "24px" }} alt="Forcer à rafraichir" />
                        </div>
                        <div className="text-center">
                            <button onClick={() => { manager.clearDataCache() }} className="btn btn-secondary btn-sm btn-warn">Vider le cache</button>
                        </div>
                    </div>
                    <hr />
                    <div className="text-center small text-muted mb-3">
                        <strong>Temps de réponse sans cache :</strong><br />
                        {Object.entries(manager._responseTimesNoCache)
                            .filter(([_, time]) => time !== null)
                            .map(([group, time]) => (
                                <span key={group} className="mx-2">
                                    {group.charAt(0).toUpperCase() + group.slice(1)}: {time} ms
                                </span>
                            ))
                        }
                    </div>
                </div>

            </>)
    }
}
